// extracted by mini-css-extract-plugin
module.exports = {"screenshareHolder":"Screenshare_screenshareHolder__YEJwk","previewHolder":"Screenshare_previewHolder__1ceeN"};